import expandIconPng from "assets/icons/Expand.png";
import collapseIcon from "assets/icons/collapse.svg";
import expandIcon from "assets/icons/expand.svg";
import styled from "styled-components";

export { collapseIcon, expandIcon, expandIconPng };

export const CollapseIconButton = styled.div`
	position: absolute;
	right: -25px;
	top: 20px;
	width: 42.8px;
	height: 42.8px;
	cursor: pointer;
	z-index: 10000;
	& img {
		width: 100%;
		height: 100%;
	}
	&.expand {
		right: -5px;
	}
`;

export const NavV2 = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 99;
	background: rgba(34, 36, 42, 0.25);
	color: #ededed;
	display: flex;
	align-items: center;
	justify-content: space-around;
	height: 70px;
	padding-left: 2rem;
`;

export const LeftSideBar = styled.div`
	background: #2e3192;
	display: flex;
	align-items: center;
	height: 500px;
	width: 100px;
`;

export const Container = styled.div`
	background: #2e3192;
`;

export const Wrapper = styled.div`
	width: 290px;
`;

export const HeaderWrapper = styled.div`
	z-index: 1010;
	padding: 20px 53px 21px 35px;
	height: 85px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0px 0px 10px #00000029;
	opacity: 1;
`;

export const Image = styled.img<{ width: string; height: string }>`
	${(props) =>
		`
    width: ${props.width};
  `}
	${(props) =>
		`
    height: ${props.width};
  `}
`;

export const WrapperrSideBar = styled.div`
	position: absolute;
	width: 290px;
	transition: width 0.2s linear;
	top: 85px;

	.pro-sidebar {
		height: calc(100vh - 85px);
		width: 100%;
		min-width: 100%;

		.pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
			background: var(--bg-secondary-color) 0% 0% no-repeat padding-box;
		}

		&.collapsed
			.pro-menu
			> ul
			> .pro-menu-item.pro-sub-menu
			> .pro-inner-list-item
			> .popper-inner {
			background: transparent;
			& ul {
				background: var(--bg-secondary-color) 0% 0% no-repeat padding-box;
				box-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);
				border-radius: 10px;
				& li {
					margin-left: 10px;
					margin-right: 10px;
				}
				&::before {
					width: 0px;
				}
			}
		}

		.pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
			position: relative;
			padding-left: 0 !important;
			margin-top: 10px;
			.pro-menu-item {
				padding-left: 20px;
				padding-right: 20px;
				padding-top: 10px;
				padding-bottom: 10px;
				margin-left: 16px;
				font-size: 16px;
			}
		}
	}

	.pro-sidebar.collapsed {
		width: 80px !important;
		min-width: 80px !important;
	}

	.pro-menu {
		ul {
			margin: 0 10px !important;
		}

		.pro-inner-list-item ul {
			margin-right: 0;
			&::before {
				content: "";
				display: block;
				width: 1px;
				height: 100%;
				background: #fff;
				position: absolute;
				top: 0;
			}
		}
	}

	.closemenu {
		color: #000;
		position: absolute;
		right: 0;
		z-index: 9999;
		line-height: 20px;
		border-radius: 50%;
		font-weight: 500;
		font-size: 22px;
		top: 50%;
		transform: translateY(-50%);
		right: -30px;
		cursor: pointer;
	}

	.pro-sidebar-inner {
		background: var(--bg-secondary-color) 0% 0% no-repeat padding-box;
		box-shadow: 0.5px 0.866px 2px 0px rgba(0, 0, 0, 0.15);
		.pro-sidebar-layout {
			overflow-y: scroll;

			&::-webkit-scrollbar {
				width: 0;
			}
			ul {
				padding: 0 5px;
				.pro-menu-item > .pro-inner-item {
					color: var(--white-color);
					font-weight: 550;
					padding: 10px 0 10px 10px !important;
				}

				.pro-sub-menu {
					padding-right: 10px;
					padding-left: 10px;
					.pro-inner-item {
						padding: 0 !important;
					}
					.pro-item-content {
						padding: 8px 0 !important;
					}
				}
				.pro-inner-item .pro-icon-wrapper {
					background-color: transparent !important;
				}
			}
			.active {
				background: rgba(255, 255, 255, 0.15) 0% 0% no-repeat padding-box;
				border-radius: 10px;
			}
		}
	}

	&.mobile {
		position: fixed;
		left: 0;
		top: 0;
		height: 100%;
		z-index: 99999;
		.pro-sidebar-inner .pro-sidebar-layout ul .pro-sub-menu {
			padding-left: 0px;
		}
	}

	@media screen and (max-width: 767px) {
		/* display: none; */
	}
`;

export const WrapperProSidebar = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	& .pro-sidebar {
		height: 100%;
	}
`;

export const WrapperMobileSidebar = styled.div`
	height: 116px;
	width: 100%;
	background: #fff;
	display: flex;
	align-items: flex-end;
	padding: 20px;
	margin-bottom: 20px;
`;
